
import {
	ifAuthenticated,
	ifAuthenticatedOnline,
	canAccess,
	AppTabs,
	Crud,
	Edit,
	Show,
	Create,
} from '@/router/index'

import Taskboard from '@/components/common/Taskboard'
import OpportunityTabs from '@/components/modules/opportunities/OpportunityTabs'
import OpportunitiesSettings from '@/components/modules/opportunities/settings/OpportunitiesSettings'
import OpportunitiesKanban from '@/components/modules/opportunities/OpportunitiesKanban'

export const opportunities = [
	{
		path: '/opportunities',
		beforeEnter: ifAuthenticated,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/opportunities/',
					text: 'opportunities',
					module: 'opportunities'
				},
				{
					to: '/opportunities/pipeline',
					text: 'Pipeline',
					module: 'opportunities'
				},
			],
		},
		children: [
			{
				path: '/opportunities/',
				name: 'opportunities-index',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('module', 'opportunities', next) },
				component: Crud,
				meta: {
					title: 'opportunities'
				},
				props: {
					modelDef: 'opportunities',
					actionIcon: 'work',
					title: 'opportunities',
					styleClass: 'mb-offset'
				}
			},
			{
				path: '/opportunities/pipeline',
				name: 'opportunities-kanban',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('module', 'opportunities', next) },
				component: OpportunitiesKanban,
				meta: {
					title: 'pipeline_opportunity'
				}
			},
		],
	},
	{
		path: '/opportunities/create',
		name: 'opportunities-create', 
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		meta: {
			title: 'new_opportunity'
		},
		props: (route) => ({
			modelDef: 'opportunities',
			defaultInput: route.params.defaultInput ? route.params.defaultInput : null,
			redirect: route.params.redirect
		}),
	},
	{ 
		path: '/opportunities/:id/edit',
		name: 'opportunities-edit', 
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		meta: {
			title: 'edit_opportunity'
		},
		props: (route) => ({
			modelDef: 'opportunities',
			id: parseInt(route.params.id),
		}),
	},
	{
		path: '/opportunities/:id',
		beforeEnter: ifAuthenticatedOnline,
		component: OpportunityTabs, 
		props: (route) => ({
			id: parseInt(route.params.id)
		}), 
		children: [
			{
				path: '',
				name: 'opportunities-show',
				beforeEnter: ifAuthenticatedOnline,
				component: Show,
				meta: {
					title: 'opportunity'
				},
				props: (route) => ({
					id:  parseInt(route.params.id),
					modelDef: 'opportunities',
					modelClass: 'opportunity',
					activities: true,
					maillogs: true,
					fileuploader: true,
					calendarEvents: true,
				}),
			},
			{
				path: '/opportunities/:id/taskboard',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('module', 'tasks', next) },
				component: Taskboard,
				meta: {
					title: 'Taskboard'
				},
				props: (route) => ({
					listableId: parseInt(route.params.id),
					listableType: 'opportunity',
				})
			},
			{
				path: '/opportunities/:id/timecards',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('module', 'timecards', next) },
				component: Crud,
				meta: {
					title: 'Timecard'
				},				
				props: (route) => ({
					modelDef: 'timecards',
					actionIcon: 'alarm',
					title: 'Timecard',
					styleClass: 'mb-offset',
					subFilters: {opportunities: parseInt(route.params.id)},
					defaultInput: {opportunity_id: parseInt(route.params.id)},
					// Le timecard non hanno una pagina di dettaglio: si aprono
					// nel dialog di modifica, come nella lista principale
					crudDialog: true,
				})
			},
			{
				path: '/opportunities/:id/quotations',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('module', 'quotations', next) },
				component: Crud,
				meta: {
					title: 'Preventivi'
				},
				props: (route) => ({
					modelDef: 'quotations',
					actionIcon: 'library_books',
					title: 'Preventivi',
					styleClass: 'mb-offset',
					subFilters: {opportunities: parseInt(route.params.id)},
				})
			}
		]
	},	
	{ 
		path: '/settingsopportunities/',
		name: 'settingsopportunities',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/settingsopportunities',
					text: 'opportunity',
				},

			],
		},
		children: [
			{
				path: '/settingsopportunities/',
				beforeEnter: ifAuthenticatedOnline,
				component: OpportunitiesSettings,
			},
		],
	},
]
